<template>
  <polygon class="tools path-tool handle node-touch-area" :points="pointsString" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  pos: number[];
  cp1: number[];
  cp2: number[];
  factor: number;
}>();

const pointsString = computed(() => {
  const [posX, posY] = props.pos;

  const direction = [props.cp2[0] - posX, props.cp2[1] - posY];

  const len = Math.sqrt(direction[0] * direction[0] + direction[1] * direction[1]);
  const absDir = [(direction[0] / len) * props.factor, (direction[1] / len) * props.factor];

  // create an arrow head pointing at `arrowHead` with base at `posX` and `posY`
  const arrowHead = [posX + absDir[0] * 100, posY + absDir[1] * 100];
  const p1 = [posX - absDir[1] * 25 + absDir[0] * 50, posY + absDir[0] * 25 + absDir[1] * 50];
  const p2 = [posX + absDir[1] * 25 + absDir[0] * 50, posY - absDir[0] * 25 + absDir[1] * 50];

  return [arrowHead, p1, p2].flat().join(' ');
});
</script>
